/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'
import {Route, Redirect, Switch} from 'react-router-dom'
import Home from './Home'
import About from './About'
import Business from './Business'
import News from './News'
import AD from './Advertisement'
import Points from './Points'
import './App.css'

class App extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			offset: 0,
			color: props.location.pathname === '/business' ? 'white' : 'black',
			toggle: false
		};
		document.onscroll = () => {
			this.setState({
				offset: window.pageYOffset >= 68 ? 1 : window.pageYOffset / 68
			})
		}
	}

	locationTo = (path) => {
		this.setState({color: path === '/business' ? 'white' : 'black'});
		this.props.history.push(path)
	};

	render() {
		return (
			<div>
				<Switch>
					<Route path="/home" component={Home}/>
					<Route path="/about" component={About}/>
					<Route path="/business" component={Business}/>
					<Route path="/news" component={News}/>
					<Route path="/ad" component={AD}/>
					<Route path="/points" component={Points}/>
					<Route path="/" render={(props) => {
						return <Redirect to="/home"/>
					}}/>
				</Switch>
				<div style={{
					padding: '40px 88px 88px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: '#585858'
				}}>
					<div>
						<span style={{color: 'white', fontSize: '12px'}}>北京东方嘉禾文化发展股份有限公司</span>
						<div style={{marginLeft: '13px', color: '#b0b0b0', fontSize: '12px'}}>
							<div style={{
								display: 'flex',
								flexDirection: 'column',
								borderLeft: '#d8d8d8 1px solid',
								paddingLeft: '10px',
								marginTop: '16px',
								float: 'left',
								marginRight: '86px'
							}}>
								<span>地址：北京市经济开发区（亦庄）科创十三街18号院锋创科技园19号楼5层</span>
								<span style={{marginTop: '13px', marginBottom: '13px'}}>电话：010-52891028</span>
								<span>邮箱：clientservice@gochinatv.com</span>
							</div>
							<div style={{
								display: 'flex',
								flexDirection: 'column',
								borderLeft: '#d8d8d8 1px solid',
								paddingLeft: '10px',
								marginTop: '16px',
								float: 'left'
							}}>
								<span>京ICP备14005713号-1</span>
								<span style={{marginTop: '13px'}}>京公安网备31011502000961号</span>
							</div>
						</div>
					</div>
				</div>
				<div className="menu-bar" style={{
					backgroundColor: (this.state.color === 'white' ? 'rgba(255,255,255,' : 'rgba(0,0,0,') + this.state.offset + ')'
				}}>
					<img alt="logo" className="menu-logo"
							 src={this.state.color === 'white' ? require('./images/logo-black.png') : require('./images/logo-white.png')}/>
					<div className={this.state.toggle ? "menu-container open" : "menu-container"}>
						<div className="menu-toggle" onClick={() => {
							this.setState({
								toggle: !this.state.toggle
							})
						}}></div>
						<ul className="menu">
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} onClick={this.locationTo.bind(this, '/home')}>首页
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/home' ? '#ff6956' : '#0000'
								}}></div>
							</li>
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} onClick={this.locationTo.bind(this, '/business')}>商家服务
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/business' ? '#ff6956' : '#0000'
								}}></div>
							</li>
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} onClick={this.locationTo.bind(this, '/ad')}>广告服务
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/ad' ? '#ff6956' : '#0000'
								}}></div>
							</li>
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} onClick={this.locationTo.bind(this, '/points')}>点位介绍
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/points' ? '#ff6956' : '#0000'
								}}></div>
							</li>
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} activeStyle={{color: '#ff6956'}} onClick={this.locationTo.bind(this, '/news')}>最新动态
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/news' ? '#ff6956' : '#0000'
								}}></div>
							</li>
							<li className="menu-li" style={{
								color: this.state.color === 'white' ? '#4e4e4e' : 'white',
								display: 'flex', flexDirection: 'column', alignItems: 'center'
							}} onClick={this.locationTo.bind(this, '/about')}>关于我们
								<div style={{
									width: '26px',
									height: '2px',
									backgroundColor: this.props.location.pathname === '/about' ? '#ff6956' : '#0000'
								}}></div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.js